import {
  Box,
  Button,
  ClickAwayListener,
  Grid,
  lighten,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Paper,
  Stack,
  Typography,
} from "@mui/material";
import React, { useMemo, useState } from "react";
import { HiOutlineArrowSmRight } from "react-icons/hi";
import { IoChevronDown, IoPersonSharp } from "react-icons/io5";
import { menuItems } from "../HeaderMenuItem/MenuItem";
import { useNavigate } from "react-router-dom";
import { FaInfoCircle } from "react-icons/fa";
import { RiLoginCircleFill } from "react-icons/ri";

const HeaderDesktop = ({ scrolled }) => {
  const [dropdown, setDropdown] = useState(null);
  const navigate = useNavigate();

  const handleMouseEnter = (menu) => () => {
    if (menu) {
      setDropdown(menu);
    }
  };

  const handleMouseLeave = () => {
    setDropdown(null);
  };

  const handleClick = (title) => {
    if (title === 'About Us') {
      navigate("/about-us");
    } else if (title === 'Price') {
      navigate("/price");
    } else {
      return null;
    }
  }

  const handleLoginClick = () => {
    navigate("/login");
  };

  const handleMenuItemClick = (path) => {
    console.log("path:", path);
    navigate(path);
    setDropdown(null);
  };
  const slugify = (title) =>
    title
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, "-")
      .replace(/(^-|-$)/g, "");

  const handleIndustriesClick = (subItem) => {
    console.log("cardInfo:", subItem?.index, subItem?.title);
    const slug = slugify(subItem?.title);
    const index = subItem?.index;
    navigate(`/industries-component/${slug}`, { state: { index } });
  };

  // Helper function to chunk array into pairs
  const chunkArray = (array, size) => {
    if (!array) return []; // Prevent error if array is undefined
    const result = [];
    for (let i = 0; i < array.length; i += size) {
      result.push(array.slice(i, i + size));
    }
    return result;
  };

  const pastelColors = [
    "#EEEFE0", "#FFEFEF", "#EBFFD8", "#FFF2EB", "#FFEDFA", "#F1E7E7",
    "#D1F8EF", "#D9EAFD", "#C6E7FF", "#F5EFFF", "#FEF9F2", "#F5EDED"
  ];

  const coloredMenuItems = menuItems.map((menuItem) => {
    if (!menuItem.content) return menuItem;

    const coloredContent = menuItem.content.map((contentItem, index) => ({
      ...contentItem,
      bgColor: pastelColors[index % pastelColors.length],
    }));

    return { ...menuItem, content: coloredContent };
  });


  return (
    <>
      {!scrolled && (
        <Stack
          sx={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "center",
            alignItems: "center",
            height: { lg: "36px", xl: "36px" },
            width: { lg: "646px", xl: "756px" },
          }}
        >
          <ClickAwayListener onClickAway={handleMouseLeave}>
            <Box sx={{ display: "flex" }}>
              {coloredMenuItems.map((item, index) => (
                <Box
                  key={index}
                  sx={{ position: "relative" }}
                  onMouseEnter={handleMouseEnter(item?.menu)}
                  onMouseLeave={handleMouseLeave}
                >
                  <Typography
                    sx={{
                      marginRight: "20px",
                      cursor: "pointer",
                      padding: "8px",
                      fontFamily: "'Roboto', sans-serif",
                      fontSize: { lg: "16px", xl: "16px" },
                      "&:hover": {
                        color: "#4c3bea",
                      },
                    }}
                    onClick={() => handleClick(item?.title)}
                  >
                    {item?.title}
                  </Typography>
                  {dropdown === item?.menu && (
                    <Box
                      sx={{
                        position: "absolute",
                        top: "40px",
                        left: 0,
                        zIndex: 10,
                        // border: "2px solid red",
                      }}
                    >
                      <Paper
                        elevation={3}
                        sx={{
                          padding: 2,
                          width: "800px",
                          maxHeight: "720px",
                          overflowY: "auto",
                        }}
                      >
                        <Grid container spacing={2}>
                          {chunkArray(item.content, 2).map(
                            (pair, pairIndex) => (
                              <Grid container item key={pairIndex} spacing={2}>
                                {pair.map((subItem, subIndex) => (
                                  <Grid
                                    item
                                    xs={6}
                                    key={subIndex}
                                    sx={{ display: "flex" }}
                                  >

                                    <ListItem
                                      button
                                      // onClick={
                                      //   item?.menu === "industries"
                                      //     ? handleIndustriesClick(
                                      //         subIndex,
                                      //         subItem.title
                                      //       )
                                      //     : handleMenuItemClick(subItem.path)
                                      // }

                                      onClick={() =>
                                        item?.menu === "industries"
                                          ? handleIndustriesClick(subItem)
                                          : handleMenuItemClick(subItem.path)
                                      }
                                      sx={{
                                        width: "100%",
                                        backgroundColor: `${subItem.bgColor}`,
                                        "&:hover": {
                                          backgroundColor: lighten(`${subItem.bgColor}`, 0.4),
                                          boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
                                        },
                                      }}

                                    >
                                      <ListItemIcon>
                                        {subItem.icon || <FaInfoCircle />}
                                      </ListItemIcon>
                                      <ListItemText
                                        primary={subItem.title}
                                        secondary={
                                          subItem.description ||
                                          "No description available"
                                        }
                                        primaryTypographyProps={{
                                          fontSize: "14px",
                                        }}
                                        secondaryTypographyProps={{
                                          fontSize: "12px",
                                        }}
                                      />
                                    </ListItem>
                                  </Grid>
                                ))}
                              </Grid>
                            )
                          )}
                        </Grid>
                      </Paper>
                    </Box>
                  )}
                </Box>
              ))}
            </Box>
          </ClickAwayListener>
        </Stack>
      )}

      <Stack
        sx={{
          display: "flex",
          flexDirection: "row",
        }}
      >
        <Button
          variant="outlined"
          startIcon={<RiLoginCircleFill style={{ color: "rgb(5, 78, 146)" }} />}
          sx={{
            marginRight: "8px",
            textTransform: "none",
            borderRadius: "8px",
            color: "rgb(5, 78, 146)",
            borderColor: "rgb(5, 78, 146)",
            boxShadow: "0 4px 8px rgba(0,0,0,0.2), 0 1px 3px rgba(0,0,0,0.1)",
            "&:hover": {
              borderColor: "rgb(31, 133, 192)",
            },
            display: "none",
          }}
          size="large"
          onClick={handleLoginClick}
        >
          Login
        </Button>
        <Button
          variant="outlined"
          sx={{
            textTransform: "none",
            borderRadius: "8px",
            backgroundColor: "rgb(5, 78, 146)",
            color: "white",
            borderColor: "rgb(5, 78, 146)",
            boxShadow: "0 4px 8px rgba(0,0,0,0.2), 0 1px 3px rgba(0,0,0,0.1)",
            overflow: "hidden",
            transition: "all 0.5s ease",
            width: "160px",
            height: "46px",
            "&:hover": {
              backgroundColor: "rgb(31, 133, 192)",
              borderColor: "rgb(31, 133, 192)",
            },
            "&:hover .text-slide": {
              transform: "translateX(-8px)",
            },
            "&:hover .arrow-slide": {
              transform: "translateX(0)",
              opacity: 1,
            },
          }}
        >
          <Box
            sx={{
              position: "relative",
              width: "100%",
              height: "100%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            {/* Text */}
            <Box
              className="text-slide"
              sx={{
                transition: "all 0.5s ease",
                fontSize: "16px",
              }}
            >
              Get started
            </Box>
            {/* Arrow */}
            <Box
              className="arrow-slide"
              sx={{
                position: "absolute",
                left: "calc(100% - 20px)", 
                transition: "all 0.5s ease",
                transform: "translateX(20px)",
                opacity: 0,
                fontSize: "16px",
                fontWeight: "bold",
              }}
            >
              →
            </Box>
          </Box>
        </Button>
      </Stack>
    </>
  );
};

export default HeaderDesktop;
